// removed by extract-text-webpack-plugin
module.exports = {"noteIconHolder":"_2V-KFTJIPhtzrbtlz7raSz","noteIconHolderMd":"_2irKEHXC-pRFQUu-tkbR8Z","noteTooltipInner":"_39sl9CrIrEg4lgzE-eCSx1","noteIconWrapper":"fsDfeUO01_V5-CixlGINw","noteIcon":"_2Gtnhd0NJjwoHZ9QWc31Nu","noteIconMd":"_1vvwknW2bRoX9WiYl6VWCV","noteTooltip":"_1pupKbbhDPRPLb6SWfiudt"};


//////////////////
// WEBPACK FOOTER
// ./src/components/NoteWrapper/NoteWrapper.scss
// module id = 460
// module chunks = 0